import IdeyaTypography from '../../../../common/antd/ideya-typography.tsx'

interface RankColumnProps {
  data: {
    rank: number
    rankTotal: number
  }
}

export const RankColumn: React.FC<RankColumnProps> = ({ data }) => {
  return (
    <IdeyaTypography.Text>
      {data.rank}/{data.rankTotal}
    </IdeyaTypography.Text>
  )
}
